import { createAsyncThunk } from '@reduxjs/toolkit';

import Thunk, { ThunkConfig } from 'src/thunks/index';
import { List } from 'src/interfaces/general';
import userNotificationActions from 'src/store/model/user_notification';
import notificationActions from 'src/store/ui/notification';

const notifications = new Thunk('notifications');
// const user_notifications = new Thunk('user_notifications');
// const notification_type = new Thunk('notification_types');

export const fetchNotificationsHistory = notifications.fetch<
  List<Model.Notification>,
  SearchParams.Base
>({
  onSuccess({ dispatch, data }) {
    dispatch(userNotificationActions.updateEntities(data.data));
    dispatch(userNotificationActions.updatePagination(data.paginator));
  },
  shouldNotify: false,
});

export const fetchNotificationCount = createAsyncThunk<void, void, ThunkConfig>(
  'notifications_count',
  async (_, { dispatch }) => {
    try {
      const { data } = await notifications.get('notifications/unread/count');

      dispatch(
        userNotificationActions.updateUnread(data.data.unread_count || 0),
      );
    } catch (err: any) {
      // dispatch(
      //   notificationActions.on({
      //     message: err.response.data?.message,
      //     type: 'error',
      //   }),
      // );
    }
  },
);

export const fetchResources = createAsyncThunk<
  void,
  SearchParams.Base,
  ThunkConfig
>('user_notifications', async (arg, { dispatch }) => {
  try {
    dispatch(userNotificationActions.updateLoading(true));

    await Promise.any([
      dispatch(
        fetchNotificationsHistory({ ...arg, order_by: 'created_at,desc' }),
      ),
      dispatch(fetchNotificationCount()),
    ]);
    dispatch(userNotificationActions.updateLoading(false));
  } catch (err) {
    dispatch(userNotificationActions.updateLoading(false));
  }
});

export const markNotificationRead = createAsyncThunk<
  void,
  { id: string },
  ThunkConfig
>('mark_as_read', async (arg, { dispatch, getState }) => {
  try {
    await notifications.put(`notifications/${arg.id}/read`, {});

    const count = getState().model.user_notification.unread_count;

    dispatch(userNotificationActions.updateRead(arg.id));
    dispatch(userNotificationActions.updateUnread(count > 0 ? count - 1 : 0));
  } catch (err: any) {
    dispatch(
      notificationActions.on({
        message: err.response.data?.message,
        type: 'error',
      }),
    );
  }
});

export const markAllRead = notifications.update<void, void>(
  'notifications/all/read',
  {
    async onSuccess({ dispatch }) {
      dispatch(userNotificationActions.updateUnread(0));

      await dispatch(fetchNotificationsHistory({}));
    },
  },
);
